export default "__VITE_ASSET__354ad2d4__"